import React from 'react'
import elevateimg from '../../Assets/Images/elevateBusinessImg1.png'

const ElevateYourBusiness = () => {
  return (
    <div className='container-fluid  '>
      <div className='row elevate-business-main-section mt-5'>
        <div className='col-lg-6 elevate-business-content'>
            <h1>Elevate your business <br />with Certification standards.</h1>
            <button className='elevate-business-btn'>Get Certified Now</button>
        </div>
        <div  className='col-lg-6'>
            <img className='elevate-business-img' src={elevateimg} alt="" />
        </div>
      </div>
    </div>
  )
}

export default ElevateYourBusiness
